// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"364":"913fcb9cab68121e20ad","712":"7e1dbaed4f80936f1596","845":"9a9425464d0f68359285","884":"4aad1fc4837670485aff","916":"2ff8b3a7a61e0ff0eeb0"}[chunkId] + ".js";
};